import { updateExpenseInBasket } from 'api/v2/expenses/basket';
import { useMutation } from 'react-query';
import useGetBasket from './useGetBasket';

const useUpdateExpenseInBakset = (onSuccess?: () => void) => {
  const basketQuery = useGetBasket();

  return useMutation(updateExpenseInBasket, {
    onSuccess: () => {
      basketQuery.refetch();
      onSuccess?.();
    },
  });
};

export default useUpdateExpenseInBakset;
